import React from 'react';
import { useLottie, type LottieOptions } from 'lottie-react';
import { isValidLottieAnimationData, normalizeLottieAnimationData, type SafeLottieProps } from '../../utils/lottie';

function SafeLottieInner({
    animationData,
    loop = true,
    style,
}: SafeLottieProps & { animationData: NonNullable<LottieOptions['animationData']> }) {
    const { View } = useLottie({ animationData, loop }, style);
    return <>{View}</>;
}

/** Renders nothing when animation JSON is missing or invalid (prevents lottie `.length` crashes). */
export function SafeLottie({ animationData, loop = true, style }: SafeLottieProps) {
    if (!isValidLottieAnimationData(animationData)) {
        return null;
    }
    const normalized = normalizeLottieAnimationData(animationData) as NonNullable<LottieOptions['animationData']>;
    return <SafeLottieInner animationData={normalized} loop={loop} style={style} />;
}
